import last from 'lodash/last';
import head from 'lodash/head';
import templateUrl from './dynamic-menus.html';

export const dynamicMenusComponent = {
    bindings: {
        menuDetails: '<',
        slugUrl: '<'
    },

    templateUrl,

    controller: class DynamicMenusComponent {
        constructor(DynamicMenusService) {
            'ngInject';

            this.dynamicMenusService = DynamicMenusService;
        }

        $onInit() {
            if (this.menuDetails.data.breadcrumb) {
                this.breadcrumb = this.menuDetails.data.breadcrumb;
                this.activeMenu = last(this.breadcrumb).name;
                this.parentState = this.dynamicMenusService.getParentStateObject();
                this.parentSlug = this.parentState ? this.parentState.slug : '';
                this.parentName = this.parentState ? this.parentState.name : '';
                this.mainMenuName = head(this.breadcrumb).name;
                this.menuId = this.menuDetails.data.menuOverviewDetails ? this.menuDetails.data.menuOverviewDetails.menu_id : null;
            }
        }

        //Menus listing Components
        isMenuListComponent() {
            switch (this.activeMenu) {
                case 'TransportationAlternatives':
                case 'PlanningResources':
                case 'GettherePrograms':
                case 'PublicationsAndDocuments':
                case 'AboutUs':
                    return true
                default:
                    return false;
            }
        }

        //Overview Components
        isEditorTemplateOverviewComponent() {
            switch (this.activeMenu) {
                case 'TransportationAlternativesOverview':
                case 'CallForHelpOverview':
                case 'BicycleAndPedestrianOverview':
                case 'RidesharingOverview':
                case 'TransportationProvidersOverview':
                case 'TelemedicineDeliveryProgramAssistanceOverview':
                case 'GetthereProgramsOverview':
                case 'ConnectionToCareOverview':
                case 'GettingThereOverview':
                case 'NewsRuralMobilityProjectOverview':
                case 'PlanningAndTechnicalAssistanceOverview':
                case 'VoucherProgramOverview':
                case 'TravelTrainingGettingOverview':
                case 'CallCenterOverview':
                case 'AboutUsOverview':
                case 'MissionHistoryOverview':
                case 'RuralHealthNetworkOverview':
                case 'PartnersStakeholdersOverview':
                case 'AdvisoryCommitteeOverview':
                case 'OurStaffOverview':
                case 'PublicationsAndDocumentsOverview':
                case 'ProgressReportsOverview':
                case 'GetthereCallCenterStatisticsOverview':
                case 'MilepostOverview':
                case 'ThereConferenceMaterialsOverview':
                case 'PlanningResourcesOverview':
                case 'IndustryOverview':
                case 'TransportationLinksOverview':
                case 'GrantApplicationsOverview':
                case 'OtherReferenceMaterialsFundingOverview':
                case 'InTheNewsOverview':
                case 'FtaFactSheetsAndCircularsOverview':
                case 'DataMappingToolOverview':
                case 'TransportationPlansOverview':
                case 'Page1Overview':
                case 'Page2Overview':
                case 'Page3Overview':
                case 'Page4Overview':
                case 'Page5Overview':
                    return true
                default:
                    return this._isNewPageComponent("Overview");
            }
        }

        //Editor Components
        isEditorTemplateComponent() {
            switch (this.activeMenu) {
                case 'TelemedicineDeliveryProgramAssistance':
                case 'ConnectionToCare':
                case 'GettingThere':
                case 'NewsRuralMobilityProject':
                case 'PlanningAndTechnicalAssistance':
                case 'VoucherProgram':
                case 'TravelTrainingGetting':
                case 'CallCenter':
                case 'MissionHistory':
                case 'RuralHealthNetwork':
                case 'PartnersStakeholders':
                case 'AdvisoryCommittee':
                case 'Industry':
                case 'TransportationLinks':
                case 'GrantApplications':
                case 'OtherReferenceMaterialsFunding':
                case 'Page1':
                case 'Page2':
                case 'Page3':
                case 'Page4':
                case 'Page5':
                    return true
                default:
                    return false;
            }
        }

        //Menu Sequence Components
        isMenuSequenceComponent() {
            switch (this.activeMenu) {
                case 'TransportationAlternativesSequence':
                case 'PlanningResourcesSequence':
                case 'GetthereProgramsSequence':
                case 'PublicationsAndDocumentsSequence':
                case 'AboutUsSequence':
                    return true
                default:
                    return false;
            }
        }

        //Report List Components
        isReportListComponent() {
            switch (this.activeMenu) {
                case 'ProgressReports':
                case 'GetthereCallCenterStatistics':
                case 'Milepost':
                case 'ThereConferenceMaterials':
                case 'FtaFactSheetsAndCirculars':
                case 'TransportationPlans':
                    return true
                default:
                    return this._isNewReportListComponent();
            }
        }

        _isNewReportListComponent() {
            const selectedMenu = last(this.breadcrumb);
            const mainMenuPages = ["Overview", "Publish", "Sequence"];

            switch (this.parentName) {
                case 'PublicationsAndDocuments':
                    const index = mainMenuPages.indexOf(selectedMenu.display_name);
                    return (index !== -1) ? false : true;
                default:
                    return false;
            }
        }

        //View Report Components
        isReportViewComponent() {
            switch (this.activeMenu) {
                case 'ProgressReportsDetails':
                case 'MilepostDetails':
                case 'ThereConferenceMaterialsDetails':
                case 'GetthereCallCenterStatisticsDetails':
                case 'FtaFactSheetsAndCircularsDetails':
                case 'TransportationPlansDetails':
                    return true;
                default:
                    return this._isNewPageComponent("Details");
            }
        }

        //Add Report Components
        isReportAddComponent() {
            switch (this.activeMenu) {
                case 'ProgressReportsAdd':
                case 'MilepostAdd':
                case 'GetthereCallCenterStatisticsAdd':
                case 'ThereConferenceMaterialsAdd':
                case 'FtaFactSheetsAndCircularsAdd':
                case 'TransportationPlansAdd':
                    return true;
                default:
                    return this._isNewPageComponent("Add");
            }
        }

        //Edit Report Components
        isReportEditComponent() {
            switch (this.activeMenu) {
                case 'ProgressReportsEdit':
                case 'MilepostEdit':
                case 'GetthereCallCenterStatisticsEdit':
                case 'ThereConferenceMaterialsEdit':
                case 'FtaFactSheetsAndCircularsEdit':
                case 'TransportationPlansEdit':
                    return true;
                default:
                    return this._isNewPageComponent("Edit");
            }
        }

        //Page publish status component
        isPagePublishStatusComponent() {
            switch (this.activeMenu) {
                case 'TransportationAlternativesPublish':
                case 'PlanningResourcesPublish':
                case 'GetthereProgramsPublish':
                case 'PublicationsAndDocumentsPublish':
                case 'AboutUsPublish':
                    return true;
                default:
                    return false;
            }
        }

        _isNewPageComponent(pageName) {
            const { display_name: displayName } = last(this.breadcrumb);
            switch (this.mainMenuName) {
                case "PublicationsAndDocuments":
                    return (this.parentName !== "" && (this.mainMenuName !== this.parentName) && displayName === pageName) ? true : false;
                default:
                    return false;
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/dynamic-menus/dynamic-menus.component.js